module.exports = __webpack_public_path__ + "./docs/img/icon-kotlin.13a0f524224177d22d445de529cbed6b.svg";